export const ptDDDs = [
  21,
  22,
  23,
  24,
  25,
  26,
  27,
  28,
  29, // Prefixos fixos
  91,
  92,
  93,
  96 // Prefixos móveis
]

export const brDDDs = [
  11, 12, 13, 14, 15, 16, 17, 18, 19, 21, 22, 24, 27, 28, 31, 32, 33, 34, 35,
  37, 38, 41, 42, 43, 44, 45, 46, 47, 48, 49, 51, 53, 54, 55, 61, 62, 63, 64,
  65, 66, 67, 68, 69, 71, 73, 74, 75, 77, 79, 81, 82, 83, 84, 85, 86, 87, 88,
  89, 91, 92, 93, 94, 95, 96, 97, 98, 99
]

const notNumbers = /\D/g
const ptMatch = /^(?:0|351)?(\d{2})(\d{6,7})$/
const brMatch = /^(?:0?55|0)?(\d{2})(\d{8,9})$/

export const isPhoneNumber = (data) => {
  const phone = String(data || '').replace(notNumbers, '')
  if (!phone || phone.startsWith('0')) return false

  const repeatNumbers = /(\d)\1{5,}/
  if (repeatNumbers.test(phone)) return false

  return true
}

export const isBrazilianPhoneNumber = (data) => {
  const phone = String(data || '')
    .replace(notNumbers, '')
    .trim()

  const match = phone.match(brMatch)
  if (!match) return false

  const ddd = parseInt(match[1], 10)
  const number = match[2]

  return brDDDs.includes(ddd) && /^[2-9]\d{7,8}$/.test(number)
}

export const isPortuguesePhoneNumber = (data) => {
  const phone = String(data || '')
    .replace(notNumbers, '')
    .trim()

  const match = phone.match(ptMatch)
  if (!match) return false

  const prefix = parseInt(match[1], 10)
  const number = match[2]

  return ptDDDs.includes(prefix) && /^\d{6,7}$/.test(number)
}

export const formatPhone = (data) => {
  const phone = String(data || '')
    .replace(notNumbers, '')
    .trim()

  if (isBrazilianPhoneNumber(phone)) {
    const match = phone.match(brMatch)
    const ddd = match[1]
    const number = match[2]
    const isMovel = number.length === 9
    const regPhone = isMovel ? /(\d{1})(\d{4})(\d{4})/ : /(\d{4})(\d{4})/
    const formatPhone = isMovel ? '$1 $2-$3' : '$1-$2'
    return `(${ddd}) ${number.replace(regPhone, formatPhone)}`
  }

  if (isPortuguesePhoneNumber(phone)) {
    const match = phone.match(ptMatch)
    const prefix = match[1]
    const number = match[2]
    const isMovel = number.length === 7
    const regPhone = isMovel ? /(\d{3})(\d{4})/ : /(\d{3})(\d{3})/
    return `(${prefix}) ${number.replace(regPhone, '$1 $2')}`
  }

  return phone
}

export const formatContact = (contact, areaCode) => {
  const ddd = contact.substr(0, 2)
  const canRemoveDDD = ddd === areaCode
  if (canRemoveDDD) return formatLocalNumber(contact, areaCode)
  const canAddZero = !canRemoveDDD && startWithDDD(toNationalNumber(contact))
  if (canAddZero) return `0${toNationalNumber(contact)}`
  return contact
}

const ddds = ['11', '12', '13', '14', '15', '16', '17', '18', '19', '21', '22', '24', '27', '28', '31', '32', '33', '34', '35', '37', '38', '41', '42', '43', '44', '45', '46', '47', '48', '49', '51', '53', '54', '55', '61', '62', '64', '65', '66', '67', '82', '71', '73', '74', '75', '77', '85', '88', '98', '99', '83', '81', '87', '86', '89', '84', '79', '68', '96', '92', '97', '91', '93', '94', '69', '95', '63']
const startWithDDD = (contact) => {
  if (contact.length <= 9) return false
  for (const ddd of ddds) {
    if (contact.startsWith(ddd)) {
      return true
    }
  }
}

export const toNationalNumber = (contact) => {
  if (contact.startsWith('0550')) return contact.substr(4)
  if (contact.startsWith('550')) return contact.substr(3)
  if (contact.startsWith('055')) return contact.substr(3)
  if (contact.startsWith('55')) return contact.substr(2)
  if (contact.startsWith('0')) return contact.substr(1)
  return contact
}

const formatLocalNumber = (destination, areaCode) => {
  const nationalNumber = toNationalNumber(destination)
  return nationalNumber.startsWith(areaCode) ? nationalNumber.substr(2) : nationalNumber
}
